module.exports = __webpack_public_path__ + "static/graph-year-2_fr-7f9f4dcea4b93ecd830f0fccfff7ad77.svg";